(function () {
  'use strict';

  var root = document.querySelector('[data-cc-number-field]');
  if (!root) return;

  var input = root.querySelector('[data-cc-number-input]');
  var label = root.dataset.label || 'Quantity';
  var property = root.dataset.property || label;
  var required = root.hasAttribute('data-required');
  var min = parseFloat(root.dataset.min);
  var max = parseFloat(root.dataset.max);
  if (isNaN(min)) min = 1;
  if (isNaN(max)) max = 10;

  function dispatch(filled) {
    document.dispatchEvent(new CustomEvent('cc:number-changed', {
      detail: { property: property, label: label, filled: filled, min: 1, required: required }
    }));
  }

  // Valid = a non-empty, numeric value within [min, max]. Whitespace/empty and
  // out-of-range never satisfy a required gate.
  function evaluate() {
    var raw = input.value.trim();
    if (raw === '') { dispatch(0); return; }
    var n = Number(raw);
    var valid = !isNaN(n) && n >= min && n <= max;
    dispatch(valid ? 1 : 0);
  }

  // Re-evaluate the gate on every keystroke, but don't fight the user mid-type.
  input.addEventListener('input', evaluate);

  // Clamp to [min, max] on commit (blur / stepper), then re-evaluate.
  input.addEventListener('change', function () {
    var raw = input.value.trim();
    if (raw !== '') {
      var n = Number(raw);
      if (!isNaN(n)) {
        if (n < min) n = min;
        if (n > max) n = max;
        input.value = n;
      }
    }
    evaluate();
  });

  // Fire once on init, respecting a pre-filled default rendered by Liquid.
  evaluate();
})();
